import { useCallback, useSyncExternalStore } from 'react';

import { getHidePhi, setHidePhi, subscribeHidePhi } from '@/services/hidePhiStore';

export default function useHidePhi() {
  const hidePhi = useSyncExternalStore(subscribeHidePhi, getHidePhi, getHidePhi);

  const toggleHidePhi = useCallback(() => setHidePhi(!getHidePhi()), []);

  return { hidePhi, setHidePhi, toggleHidePhi };
}
